import React from 'react';
import {
  // Checkbox,
  ActivityIndicator,
  DarkButton,
  Select,
  SearchInput,
  FloatingLabelInput
} from '@lyearn-team/frontend-components';
import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import DarkSelect from '@lyearn-team/frontend-components/dist/DarkSelect/DarkSelect';
import DarkCheckbox from '@lyearn-team/frontend-components/dist/DarkCheckbox/DarkCheckbox';
import c from 'classnames';
import { DatePicker } from 'antd';
import moment from 'moment';

import Icon from '../../helper/Icon';
import s from './style';
import newSetPropertiesToUserMutation from '../../admin/mutations/user/NewSetPropertiesToUserMutation';
import setNameOfUserMutation from '../../mutations/editAccount/SetNameOfUserMutation';
import request from '../../helper/NetworkLayer';

class UserInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmCheckbox: false,
      showLoader: false,
      disabledButton: true,
      dateFocused: false
    };
    this.userValues = {
      name: {
        id: '',
        value: this.props.user.name,
        type: 'TEXT'
      }
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  onFieldNameChange = (fieldName, type) => e => {
    const value = e.target.value.trim();
    if (value === '') {
      this.userValues[fieldName].value = [];
    } else if (type === 'NUMBER') {
      this.userValues[fieldName].value = [value.toString()];
    } else {
      this.userValues[fieldName].value = [value];
    }
    this.validateUserForm();
  };

  onSelectChange = key => type => values => {
    if (type === 'DATE') {
      const date = values.toDate().toISOString();
      this.userValues[key].value = [date];
    } else if (type === 'SINGLE_SELECT') {
      this.userValues[key].value = [values.value];
    } else if (type === 'MULTI_SELECT') {
      const updatedValues = values.map(value => value.value);
      this.userValues[key].value = updatedValues;
    }
    this.validateUserForm();
  };

  onDatePickerFocus = () => {
    this.setState({ dateFocused: !this.state.dateFocused });
  };

  getUsers = async () => {
    const { user } = this.props;
    const companyResponse = await request('/graphql', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        operationName: null,
        query: `
        {
          company(id: "${user.companyId}") {
            propertiesRequiredOnRegistration {
              edges {
                node {
                  pid
                  name
                  values {
                    id
                    value
                  }
                  type
                }
              }
            }
          }
          user(id: "${user.pid}") {
            customProperties {
              customProperty {
                pid
                name
                type
              }
              values {
                id
                value
              }
            }
          }
        }
      `,
        variables: null
      })
    });
    const companyJSONResponse = await companyResponse.json();
    const requiredFields = companyJSONResponse.data.company.propertiesRequiredOnRegistration.edges.map(
      ({ node: { name, pid, values, type } }) => ({ pid, name, values, type })
    );
    requiredFields.forEach(field => {
      this.userValues[field.name] = {
        id: field.pid,
        value: '',
        type: field.type,
        values: field.values
      };
    });
    companyJSONResponse.data.user.customProperties.forEach(property => {
      const { pid, name, type } = property.customProperty;
      const requiredField = requiredFields.find(field => field.pid === pid);
      if (requiredField) {
        this.userValues[name] = {
          id: pid,
          value: property.values.map(v => v.id),
          type,
          values: requiredField.values
        };
      }
    });

    this.forceUpdate();
  };

  getPropertiesForUsers = () => {
    const properties = [];
    Object.entries(this.userValues).forEach(objectAsArray => {
      const value = objectAsArray[1];
      if (value.id) {
        const id = value.id;
        const fieldValue = value.value;
        properties.push({
          id,
          values: fieldValue
        });
      }
    });
    return properties;
  };

  getSelectedOptions = (value, values) => value.map(v => values.find(val => val.id === v)) || [];

  validateUserForm = () => {
    const { confirmCheckbox } = this.state;
    const isNameValid = this.userValues.name.value.length !== 0;
    let isValuesValid = true;
    Object.entries(this.userValues).forEach(([key, value]) => {
      isValuesValid = isValuesValid && value.value.length !== 0;
    });
    if (!isNameValid || !isValuesValid || !confirmCheckbox) {
      this.setState({
        disabledButton: true
      });
    } else {
      this.setState({
        disabledButton: false
      });
    }
  };

  checkBoxChanged = e => {
    const value = e.target.checked;
    this.setState(
      {
        confirmCheckbox: value
      },
      this.validateUserForm
    );
  };

  redirectToHome = isFMOutReachInstance => {
    if (isFMOutReachInstance) {
      window.__refetchUserData();
    } else {
      window.location.href = '/#/learner';
      window.location.reload(true);
    }
  };

  submitForm = () => {
    const userId = this.props.user.pid;
    const properties = this.getPropertiesForUsers();
    const propertiesObject = {
      userId,
      properties
    };
    this.setState({
      showLoader: true
    });
    newSetPropertiesToUserMutation(
      global.relayModernEnvironment,
      propertiesObject,
      () => {
        const isNameChanged = this.props.user.name !== this.userValues.name;
        if (isNameChanged) {
          const userNameObject = {
            userId,
            name: this.userValues.name.value
          };
          setNameOfUserMutation(global.relayModernEnvironment, userNameObject, () => {
            this.redirectToHome(this.props.isFMOutReachInstance);
          });
        } else {
          this.redirectToHome(this.props.isFMOutReachInstance);
        }
      },
      err => {
        console.log(err);
        this.setState({
          showLoader: false
        });
      }
    );
  };

  renderPropertyValueOption = valueObj => ({
    label: valueObj.value,
    value: valueObj.id
  });

  renderNewFields = () => {
    const newFieldsArray = [];
    Object.entries(this.userValues).forEach(([key, value]) => {
      const fieldValue = value.value;
      const type = value.type;
      let item;
      if (type === 'TEXT') {
        item = (
          <div className={s.inputWrapper()} style={{ marginTop: '30px' }}>
            {/* <label className={s.inputLabel()}>{key}</label> */}
            <label className={s.inputLabel()}>{key}</label>
            <DarkBoxInput
              label={key.toUpperCase()}
              placeholder={key.toUpperCase()}
              defaultValue={fieldValue}
              onChange={this.onFieldNameChange(key, type)}
            />

            {/* <SearchInput
              showSearchIcon={false}
              wrapperProps={{ className: s.inputStyle() }}
              defaultValue={fieldValue}
              onChange={this.onFieldNameChange(key, type)}
              placeholder="Enter text here..."
            /> */}
          </div>
        );
      } else if (type === 'MULTI_SELECT' || type === 'SINGLE_SELECT') {
        const propertyOptions = value.values.map(this.renderPropertyValueOption);
        const selectedOptions =
          (value.value.length &&
            this.getSelectedOptions(value.value, value.values).map(
              this.renderPropertyValueOption
            )) ||
          [];
        item = (
          <div className={s.inputWrapper()}>
            <label className={s.inputLabel()}>{key}</label>
            <DarkSelect
              onSelect={this.onSelectChange(key)(type)}
              label="Select from options"
              options={propertyOptions}
              multiple={type === 'MULTI_SELECT'}
              selectedOptions={selectedOptions}
            />
          </div>
        );
      } else if (type === 'DATE') {
        const date = fieldValue[0] && moment(fieldValue[0]);
        item = (
          <div className={s.inputWrapper()}>
            <label className={s.inputLabel()}>{key}</label>
            <div style={{ float: 'left', marginBottom: '15px' }}>
              <DatePicker
                numberOfMonths={1}
                date={date || null}
                defaultValue={date}
                focused={this.state.dateFocused}
                onOpenChange={this.onDatePickerFocus}
                onChange={this.onSelectChange(key)(type)}
                disabledDate={current => current && current < moment().endOf('day')}
              />
            </div>
          </div>
        );
      } else if (type === 'NUMBER') {
        item = (
          <div className={s.inputWrapper()}>
            <label className={s.inputLabel()}>{key}</label>
            <DarkBoxInput
              type="number"
              label={key.toUpperCase()}
              placeholder={key.toUpperCase()}
              defaultValue={fieldValue}
              onChange={this.onFieldNameChange(key, type)}
            />
          </div>
        );
      }
      newFieldsArray.push(item);
    });
    return newFieldsArray;
  };

  renderLoader = () => (
    <ActivityIndicator
      svgColor="#fff"
      width={15}
      height={15}
      style={{ marginRight: '7px', marginBottom: '-2px' }}
    />
  );

  render() {
    const { confirmCheckbox, showLoader, disabledButton } = this.state;
    const email = this.props.user.email;
    const isFMOutReach = this.props.user.companyId === '5ea82fdb315efb00085cae0f';
    return (
      <div className={s.container()}>
        <header className={s.innerPageHeader()}>
          <a href="javascript:;">
            <img
              src="https://dndw32r4edmw5.cloudfront.net/lyearn/lyearnWebsite/images/lyearn-gray-logo.png"
              alt="companyLogo"
              className={s.logoImage()}
            />
          </a>
        </header>
        <div className={s.root()}>
          <h1 className={s.title()}>Tell us a little more about yourself!</h1>
          <h2 className={s.subTitle()}>
            Help us get you hands-on by filling out the following details:
          </h2>
          <div className={s.inputWrapper()}>
            <label className={s.inputLabel()}>Email ID</label>
            <DarkBoxInput label="Email id*" defaultValue={email} disabled={true} />
          </div>
          {this.renderNewFields()}
          <div className={c(s.checkboxStyle(), s.checkBoxWrapper)}>
            <DarkCheckbox
              label=""
              defaultChecked={confirmCheckbox}
              onChange={this.checkBoxChanged}
            />
            {!isFMOutReach ? (
              `By registering, you confirm you have read and agree to the Terms of Use and the Master
            Subscription Agreement.`
            ) : (
              <span>
                I ACCEPT and have read the terms and conditions in the{' '}
                <a href="https://www.forcemanagement.com/fmoutreach-terms-and-conditions">
                  Force Management Outreach Program End User License Agreement
                </a>
                .
              </span>
            )}
          </div>
          <DarkButton
            size="large"
            type="filled"
            disabled={disabledButton}
            onClick={this.submitForm}
            className={s.doneButton}
          >
            {showLoader && this.renderLoader()}
            Done
          </DarkButton>
          {/* <button
            className={s.continueButton(disabledButton)}
            disabled={disabledButton}
            onClick={this.submitForm}
          >
            {showLoader && this.renderLoader()}
            Done
          </button> */}
        </div>
        <footer className={s.innerPageFooter()}>
          <a href="/privacy-policy" className={s.footerText()}>
            Privacy policy
          </a>
          <p className={s.footerText()}>
            Download Lyearn app:
            <a
              href="https://itunes.apple.com/us/app/lyearn/id1085008933"
              target="_blank"
              title="Opens in a new window"
              className={s.footerAppleIcon()}
            >
              <Icon icon="android" fill="rgba(131,146,167,0.7)" size="24px" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.lyearn.rnapp2"
              target="_blank"
              title="Opens in a new window"
              className={s.footerAndroidIcon()}
            >
              <Icon
                icon="apple"
                fill="rgba(131,146,167,0.7)"
                size="24px"
                viewBox="0 0 35.676 35.676"
              />
            </a>
          </p>
        </footer>
      </div>
    );
  }
}

export default UserInfoForm;
